import { Spinner } from '../spinner';

interface PreloaderProps {
  preloaderOpacity?: number | string;
  top?: boolean;
}

export const Preloader = (props: PreloaderProps) => {
  return (
    <div
      className='absolute top-0 bottom-0 left-0 ml-2.5 flex h-6.25 w-full items-center justify-center bg-white'
      style={{ opacity: props.preloaderOpacity || 0, zIndex: props.top ? 1000 : undefined }}
    >
      <Spinner />
    </div>
  );
};
